export * from './register-form.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/register/index.ts